"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Event = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 48,
  height: 54,
  viewBox: "0 0 48 54",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C12.76 0 13.04 0 13.6 0h2.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C18 .76 18 1.04 18 1.6V6h12V1.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C30.76 0 31.04 0 31.6 0h2.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C36 .76 36 1.04 36 1.6V6h10a2 2 0 012 2v38.308c0 2.675-.279 3.645-.801 4.623a5.452 5.452 0 01-2.268 2.268c-.978.523-1.948.801-4.623.801H7.692c-2.675 0-3.645-.279-4.623-.801A5.452 5.452 0 01.801 50.93c-.482-.903-.757-1.799-.796-4.035L0 21H0V8a2 2 0 012-2h10V1.6zM6 21v25.691l.018.637.032.47.014.13.348.035.892.032H40.69l.637-.018.47-.032.13-.016.035-.346.032-.892V21H6zm8.303 10.626a2.766 2.766 0 013.879 0l3.879 3.832 7.757-7.664a2.766 2.766 0 013.879 0 2.687 2.687 0 010 3.832L24 41.206a2.766 2.766 0 01-3.879 0l-5.818-5.748a2.687 2.687 0 010-3.832z",
  fill: "#DDE0E5",
  className: "fill"
}));
var _default = exports.default = Event;